<template>
    <div class="competition_wrap pb17 ">
        <div class="competition_item application_item not_sort">
            <div class="competition_input">
                <el-input :placeholder="`${$t('st')}`" v-model="searchInput"
                          @input="setData('searchInput',searchInput)"
                          @keypress.native.enter="setFilterFunc(searchInputOption,searchInput)"></el-input>
                <button class="competition_btn" @click="setFilterFunc(searchInputOption,searchInput)"></button>
            </div>
        </div>
        <div class="competition_btn_wrap ">
            <button class="c_filter_btn ma0 " @click="openFilter('curation-filter-request-filter')"></button>
        </div>
        <div class="clear"></div>
        <curation-filter-request-filter></curation-filter-request-filter>
    </div>
<!--    <div class="search_item mb19">
        <div class="filter_category_box mr5">
            <el-select id="category" v-model="searchInputOption" class="my_filter select"
                       popper-class="select_style"
                       :popper-append-to-body="false">
                <el-option :value="'ina'" :label="$t('subject')"></el-option>
                <el-option :value="'hash'" :label="$t('hashtag')"></el-option>
                <el-option :value="'orni'" :label="$t('k_creator')"></el-option>
                <el-option :value="'cuni'" :label="$t('curator_in_charge')"></el-option>
            </el-select>

        </div>
        <div class="search_input mypage_search_input">
            <el-input :placeholder="$t('st')" v-model="searchInput"
                      @input="setData('searchInput',searchInput)"
                      @keypress.native.enter="setFilterFunc(searchInputOption,searchInput)">
            </el-input>
            <button class="search_btn mypage_search_btn"  @click="setFilterFunc(searchInputOption,searchInput)">
            </button>
        </div>
        <button class="search_filter_btn" @click="openFilter('curation-filter-request-filter')"></button>
        <curation-filter-request-filter></curation-filter-request-filter>
    </div>-->
</template>

<script>
import {curationStatus} from "@/service/curationService";
import curationUtil from "@/components/curation/curationUtil";
import CurationFilterRequestFilter from "@/components/filter/CurationFilterRequestFilter";

const {filterConfig} = curationUtil;
export default {
    name: "CurationFilterRequestLayout",
    mixins: [],
    components: {
        CurationFilterRequestFilter
    },
    inject: ['setFilter'],
    provide() {
        return{

        }
    },
    props: {
        filterData: {default: () => {}},
    },
    data() {
        return{
            sortOption: 'i.updated_at',
            searchInput: '',
            searchInputOption: 'ina',
            filterCategory: [],
            filterStatus: [],
            filterEdition: [],
            filterType: [],
            filterItemStatus: [],
            filterCurationStatus: [],
            priceInput: ["", ""],
            filterDate: '',
            filterRequestDate: '',

            curationStatus: curationStatus,
            showPopover: false,
        }
    },
    beforeRouterEnter() {},
    created() {
        this.setterFilterDataInData();
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
    },
    methods:{
        openFilter(name) {
            this.$modal.show(name, {sortData: this.sortData, filterData: this.filterData});
        },
        setterFilterDataInData() {
            let classnames = Object.keys(this.filterData);
            classnames.forEach(classname => {
                let obj = this.filterData[classname];
                let type = filterConfig[obj.key].type;
                if (this.hasOwnProperty(classname)) {
                    // this[classname] =
                    if (type == 'query') {
                        this[classname] = obj.query;
                        if (this.hasOwnProperty(classname + 'Option')) {
                            this[classname + 'Option'] = obj.key;
                        }
                    } else if (type === 'between') {
                        this[classname] = [obj.start, obj.end];
                    } else if (type === 'match') {
                        if (isNaN(obj.value)) {
                            this[classname] = obj.value;
                        } else {
                            this[classname] = Number(obj.value);
                        }

                    } else if (type === 'terms') {
                        this[classname] = obj.terms;
                    }

                }
            })
        },
        sortChange(data) {
            if (data === 'priceAsc') {
                this.setFilterFunc('obt', 'i_price');
                this.setFilterFunc('obs', 'asc');
            } else if (data === 'priceDesc') {
                this.setFilterFunc('obt', 'i_price');
                this.setFilterFunc('obs', 'desc');
            } else {
                this.setFilterFunc('obt', data);
                this.setFilterFunc('obs', 'desc');
            }
        },
        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },
        runPriceFilter() {
            this.setFilterFunc('pr', this.priceInput);
            // this.showPopover = false;
        },
        setData(key, value) {
            this[key] = value;
        },
        openModal(name) {
            this.$modal.show(name);
        },
    },
    watch: {

    },
}
</script>

<style scoped>

</style>
